global.userChequeBankTransactionList = global.API_USER_URL+'userChequeBankTransactionList/';

global.createChequeDepositTransaction = global.API_USER_URL+'createChequeDepositTransaction/';
global.editChequeDepositTransaction = global.API_USER_URL+'editChequeDepositTransaction/';
global.userChequeTransactionDelete = global.API_USER_URL+'userChequeTransactionDelete/';
global.userChequeTransactionDeleteByCheckPage = global.API_USER_URL+'userChequeTransactionDeleteByCheckPage/';
global.userBankChequeTransactionDelete = global.API_USER_URL+'userBankChequeTransactionDelete/';
